export function debounce(fn, delay) {
  // 记录上一次的延时器
  let timer = null;
  // eslint-disable-next-line no-var
  delay = delay || 200;
  return function () {
    const args = arguments;
    const that = this;
    // 清除上一次延时器
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(that, args);
    }, delay);
  };
}

// 去除首尾空格
export function trimStr(str) {
  return str.replace(/(^\s*)|(\s*$)/g, "");
}

// js 乘法函数
// 调用：accMul(arg1,arg2)
// 返回值：arg1乘以arg2的精确结果
export function accMul(arg1, arg2) {
  let m = 0;
  const s1 = arg1.toString();
  const s2 = arg2.toString();
  try {
    m += s1.split(".")[1] ? s1.split(".")[1].length : 0;
  } catch (e) {
    console.log(e);
  }
  try {
    m += s2.split(".")[1] ? s2.split(".")[1].length : 0;
  } catch (e) {
    console.log(e);
  }
  return (
    (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
    Math.pow(10, m)
  );
}

/**
 * @description 不四舍五入取小数
 * @param num 数字
 * @param n 小数点位数
 */
export const toFixedDigit = (num, n) => {
  // 保留n位
  if (typeof num !== "number") {
    return false;
  }
  num = num.toString();
  let result = "";
  const zeroResult = function (n) {
    let zero = "";
    for (let i = 0; i < n; i++) {
      zero += "0";
    }
    return zero;
  };
  if (num % 1 === 0) {
    // 整数
    result = num + "." + zeroResult(n);
  } else {
    // 小数
    const num1 = num.split(".");
    if (num1[1].length < n) {
      result = num1[0] + "." + num1[1] + zeroResult(n - num1[1].length);
    } else {
      result = num1[0] + "." + num1[1].substring(0, n);
    }
  }
  return result;
};
